// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "RadioButton_radioContainer__D7Bsb";
var _3 = "'../../../shared.module.css'";
var _4 = "RadioButton_subQuestion__22MqT";
export { _1 as "md", _2 as "radioContainer", _3 as "shared", _4 as "subQuestion" }
